import { Breadcrumb as Breadcrumb$1 } from './src/Breadcrumb.js';
import { Item } from './src/BreadcrumbItem.js';

const Breadcrumb = Breadcrumb$1;
Breadcrumb.Item = Item;

export { Breadcrumb };
//# sourceMappingURL=index.js.map
